import Qs from 'qs';

const convertToArray = object => {
  const array = Object.keys(object).map(key => ({
    key,
    values: object[key],
  }));
  return array.filter(({ values }) => values);
};

export default {
  async fetchData({ commit, state, rootGetters }, { type }) {
    const lessItemsInList = !rootGetters['auth/isLogged'];
    try {
      const endpoint = type === 'products' ? 'frequently-bought' : 'search';
      commit('layout/setLoader', true, { root: true });
      const activeFilters = state[type].activeFilters;

      const params = {
        query: type === 'search' ? state[type].query : state[type].activeFilters.itemNameOrCode,
        categoryIds:
          type === 'search'
            ? state[type].categories.join(', ')
            : state[type].activeFilters.categoryId,
        ...(state[type].pagination.limit && {
          limit: lessItemsInList ? state[type].pagination.limit - 1 : state[type].pagination.limit,
        }),
        ...(state[type].pagination.offset && {
          offset: lessItemsInList
            ? state[type].pagination.offset -
              state[type].pagination.offset / state[type].pagination.limit
            : state[type].pagination.offset,
        }),
        ...(state[type].sort && { orderBy: state[type].sort }),
        ...(state[type].period && { period: state[type].period }),
        ...(state[type].inkAndTonersOnly && { inkAndTonersOnly: state[type].inkAndTonersOnly }),
        ...(state[type].device && { device: state[type].device }),
        ...(state[type].deviceBrand && { deviceBrand: state[type].deviceBrand }),
        ...(state[type].deviceModel && { deviceModel: state[type].deviceModel }),
        ...(state[type].oemCode && { oemCode: state[type].oemCode }),
        filters: convertToArray(activeFilters),
        ...(state[type].promotionGroupId && { promotionGroupId: state[type].promotionGroupId }),
        ...(state[type].onlyEco && { promotionGroupId: 15050 }),
        ...(state[type].brandId && { brandId: state[type].brandId }),
        ...(state[type].catalogSubsetId && { catalogSubsetId: state[type].catalogSubsetId }),
        ...(state[type].atsQuery && { 'ats-query': state[type].atsQuery }),
        ...(state[type].onlyPalletPacks && { onlyPalletPacks: state[type].onlyPalletPacks }),
      };

      if (type === 'offers') params.filters.push({ key: 'offerZone', values: [1] });
      else if (type === 'prices') params.filters.push({ key: 'myOfferOnlyFilter', values: [1] });
      const {
        data: {
          countTotal,
          products,
          filters,
          orderByOptions: sortFilters,
          categoryFilter,
          categoryId,
          categoryName,
          categoryLevel,
          breadcrumbs,
          fuzzySearch,
        },
      } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/products/${endpoint}`, {
        params,
        paramsSerializer: params => {
          return Qs.stringify(params);
        },
        useCache: true,
      });

      commit('setItems', { type, value: products });
      commit('setPagination', {
        type,
        value: {
          ...state[type].pagination,
          countTotal,
        },
      });
      commit('setSortFilters', { type, value: sortFilters });

      if (type === 'search') {
        commit('setFilters', { type, value: filters });
        commit('setCategoryFilter', { type, value: categoryFilter });
        commit('setCategoryId', { type, value: categoryId });
        commit('setCategoryName', { type, value: categoryName });
        commit('setCategoryLevel', { type, value: categoryLevel });
        commit('setBreadcrumbs', { type, value: breadcrumbs });
        commit('setFuzzySearch', { type, value: fuzzySearch });
        commit('setResetFiltersFlag', { type, value: false });
      }

      commit('setPopstate', { type, value: false });
      commit('layout/setLoader', false, { root: true });
    } catch {}
  },

  async changeFilters({ commit, dispatch, state }, { type, name, value }) {
    try {
      if (state[type].resetFiltersFlag) return;
      commit('setActiveFilter', { type, name, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changePagination({ commit, dispatch }, { type, value }) {
    try {
      commit('setPagination', { type, value });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changePeriod({ state, commit, dispatch }, { type, value }) {
    try {
      commit('setPeriod', { type, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changeSort({ state, commit, dispatch }, { type, value }) {
    try {
      commit('setSort', { type, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async changeCategory({ state, commit, dispatch }, { type, value }) {
    try {
      commit('setCategories', { type, value });
      commit('setPagination', { type, value: { ...state[type].pagination, offset: 0 } });
      // await dispatch('resetFilters', { type });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async resetFilters({ commit, dispatch }, { type }) {
    try {
      commit('setResetFiltersFlag', { type, value: true });
      commit('setActiveFilters', { type, filters: {} });
      await dispatch('fetchData', { type });
    } catch {}
  },

  async submitHeaderForm({ commit, dispatch }, { type, value }) {
    try {
      commit('resetState', { type });
      commit('setQuery', { type, value: value.query ? value.query : '' });
      if (!value.categories) {
        commit('setCategories', { type, value: [] });
      } else {
        commit('setCategories', { type, value: value.categories });
      }
      await dispatch('fetchData', { type });
    } catch {}
  },

  async submitTonersInks({ commit, dispatch }, { type, value }) {
    try {
      commit('resetState', { type });

      commit('setInkAndTonersOnly', { type, value: value.inkAndTonersOnly });

      if (value.query) {
        commit('setQuery', { type, value: value.query });
      }

      if (value.device) {
        commit('setDevice', { type, value: value.device });
      }

      if (value.oemCode) {
        commit('setOemCode', { type, value: value.oemCode });
      }

      if (value.deviceBrand) {
        commit('setDeviceBrand', { type, value: value.deviceBrand });
      }

      if (value.deviceModel) {
        commit('setDeviceModel', { type, value: value.deviceModel });
      }

      await dispatch('fetchData', { type });
    } catch {}
  },
};
